import { render } from "./AdviesEndView.vue?vue&type=template&id=7b4cb6fa&scoped=true"
import script from "./AdviesEndView.vue?vue&type=script&lang=js"
export * from "./AdviesEndView.vue?vue&type=script&lang=js"

import "./AdviesEndView.vue?vue&type=style&index=0&id=7b4cb6fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4cb6fa"]])

export default __exports__